import React from "react";

const InfoLibrary = [
  {
    title: "Help",
    id: "101",
  },
  {
    title: "Root Cause Help",
    id: "RC101",
  },
  {
    title: "Alarm Column Chart Help",
    id: "A201",
    }, {
        title: "Alarm Grid Help",
        id: "A202",
    },
  {
    title: "Device Help",
    id: "D101",
    }, {
        title: "Trigger Grid Help",
        id: "T101",
    }, {
        title: "Trigger Chart Help",
        id: "T102",
    }, {
        title: "Timeline Help",
        id: "TL101",
    },
    {
        title: "Machine Times Chart Help",
        id: "MT101",
    },
    {
        title: "General Filters Selection Help",
        id: "0",
    },
];

export default InfoLibrary;